import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const LOGO_URL = "https://customer-assets-39nsmqrw.emergentagent.net/job_logistics-platform-61/artifacts/32hvn4co_Logo%20Triplem_sl.jpg";

export const fileUrl = (fileId) =>
  `${API}/files/${fileId}?auth=${encodeURIComponent(localStorage.getItem("tm_token") || "")}`;

export const downloadUrl = (fileId) =>
  `${API}/files/${fileId}?download=1&auth=${encodeURIComponent(localStorage.getItem("tm_token") || "")}`;

export const proofPdfUrl = (shipmentId) =>
  `${API}/shipments/${shipmentId}/delivery-proof.pdf?auth=${encodeURIComponent(localStorage.getItem("tm_token") || "")}`;

export const albaranPdfUrl = (shipmentId) =>
  `${API}/shipments/${shipmentId}/albaran.pdf?t=${Date.now()}&auth=${encodeURIComponent(localStorage.getItem("tm_token") || "")}`;

export const entradaPdfUrl = (entryId) =>
  `${API}/warehouse/${entryId}/entrada.pdf?t=${Date.now()}&auth=${encodeURIComponent(localStorage.getItem("tm_token") || "")}`;

export const decaPdfUrl = (shipmentId) =>
  `${API}/shipments/${shipmentId}/deca.pdf?t=${Date.now()}&auth=${encodeURIComponent(localStorage.getItem("tm_token") || "")}`;

export async function lookupPostal(cp) {
  if (!/^\d{5}$/.test(cp)) return null;
  try {
    const r = await fetch(`https://api.zippopotam.es/es/${cp}`);
    if (!r.ok) return null;
    const d = await r.json();
    const p = d.places && d.places[0];
    if (!p) return null;
    return { poblacion: p["place name"] || "", ciudad: p["state"] || "" };
  } catch { return null; }
}

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("tm_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo salió mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
